import { defineMessages } from 'react-intl';

export default defineMessages({
    fcaLink: {
        id: '_.true_layer.fca_link',
        defaultMessage: 'FCA'
    },
    fcaLinkText: {
        id: '_.true_layer.fca_link_text',
        defaultMessage:
            "We're registered with the {link} for the provision of payment services, which allows us to offer Open Banking"
    },
    connectButton: {
        id: '_.true_layer.connect_button',
        defaultMessage: 'Connect your account'
    },
    pdfOption: {
        id: '_.true_layer.pdf_option',
        defaultMessage: "Don't want to link your account? {openModal}"
    },
    uploadStatements: {
        id: '_.true_layer.upload_statements',
        defaultMessage: 'Upload bank statements'
    },
    linkedAccountHeading: {
        id: '_.true_layer.linked_account_heading',
        defaultMessage:
            '{providerName}account ending in {accountNumber} is linked'
    },
    linked: {
        id: '_.true_layer.linked',
        defaultMessage: 'Great – you’ve linked your bank account.'
    },
    noPermission: {
        id: '_.true_layer.no_permission',
        defaultMessage: 'We didn’t get your permission.'
    },
    noPermissionButton: {
        id: '_.true_layer.no_permission_button',
        defaultMessage: 'Upload your bank statements instead?'
    },
    failed: {
        id: '_.true_layer.failed',
        defaultMessage: 'Hmm, that didn’t work.'
    },
    tryAgain: {
        id: '_.true_layer.try_again',
        defaultMessage: 'Try again or {button} instead.'
    },
    tryAgainButton: {
        id: '_.true_layer.try_again_button',
        defaultMessage: 'upload your bank statements'
    },
    cannotLinkAccount: {
        id: '_.true_layer.cannot_link',
        defaultMessage: "Don't want to link your account? {openModal}"
    }
});
